export enum WarningType {
  Error = 'error',
  Warning = 'warning',
  Info = 'info',
}
